import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { handleTermsPage } from '../../../../utils/utilityEtc';
import { A } from '../../../common';
// import useAmplitude from '../../../../hooks/useAmplitude';

function Agreed({
  agreeds,
  onChangeAgreeds
}) {
  const { t } = useTranslation();
  // const { setAmplitudeLog } = useAmplitude();

  const [allCheck, setAllCheck] = useState(false);

  const handleChange = useCallback((e) => {
    const name = e.target.name;
    const checked = e.target.checked

    if (name === 'all') {
      setAllCheck(checked);
      onChangeAgreeds({ terms: checked, privacy: checked, marketing: checked });
    } else {
      const temp = {
        ...agreeds, [name]: checked
      }
      onChangeAgreeds(temp);
      if (Object.values(temp).indexOf(false) > -1) setAllCheck(false)
      else setAllCheck(true);
    }

  }, [agreeds]);

  return (
    <div className="chk_wrap">
      <div className="chk_box">
        <input
          type="checkbox"
          id="all"
          name="all"
          checked={allCheck}
          onChange={handleChange}
        />
        <label htmlFor="all">
          {t("MY_02_01.msg004")}
        </label>
      </div>
      <div className="chk_box">
        <input
          id="terms"
          type="checkbox"
          name="terms"
          checked={agreeds.terms}
          onChange={handleChange}
        />
        <label htmlFor="terms">
          {t("MY_02_01.msg005")}
        </label>
        <div className="right">
          <A onClick={() => handleTermsPage('terms')} className="arr"><img src="./static/images/icon/link_join_48x48@2x.png" alt="" /></A>
        </div>
      </div>
      <div className="chk_box">
        <input
          id="privacy"
          type="checkbox"
          name="privacy"
          checked={agreeds.privacy}
          onChange={handleChange}
        />
        <label htmlFor="privacy">
          {t("MY_02_01.msg006")}
        </label>
        <div className="right">
          <A onClick={() => handleTermsPage('privacy')} className="arr"><img src="./static/images/icon/link_join_48x48@2x.png" alt="" /></A>
        </div>
      </div>
      <div className="chk_box">
        <input
          id="marketing"
          type="checkbox"
          name="marketing"
          checked={agreeds.marketing}
          onChange={handleChange}
        />
        <label htmlFor="marketing">
          {t("MY_02_01.msg008")}
        </label>
        <div className="right">
          <A onClick={() => handleTermsPage('marketing')} className="arr"><img src="./static/images/icon/link_join_48x48@2x.png" alt="" /></A>
        </div>
      </div>
    </div>
  );
}

export default Agreed;